import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import CachedIcon from "@mui/icons-material/Cached";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import {
  AppBar,
  Box,
  Button,
  Card,
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  get_user_details,
  getAdminPrescriptionlist,
  getCompounderOrderList,
  getDoctorsPrescriptionlist,
  getPrescriptionID,
  getReviewPrescriptionForAdmin,
  getUserPrescriptionCount,
} from "../api/api";
import imgUrl from "../assets/images/imgUrl";
import darkRoomNotificationSound from "../assets/images/sounds/dark_room_notification.mp3"; // replace with your actual sound file
import BasicDateRangePicker from "../components/CalendarComp";
import MainLoader from "../components/MainLoader";
import SidebarComp from "../components/Sidebar";
import paginationFactory from "react-bootstrap-table2-paginator";
import moment from "moment";
import FulfillmentDialogueBox from "../components/FulfillmentDialogueBox";

const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const audio = new Audio(darkRoomNotificationSound);

const AllPrescribedData = () => {
  const userInfo =
    sessionStorage.getItem("loggedInUserData") &&
    JSON.parse(sessionStorage.getItem("loggedInUserData"));
  const loggedInDoctorInfo = userInfo && userInfo;

  const playMusic = () => {
    audio.play().catch((err) => console.log("Audio play failed:", err));
  };

  // console.log(loggedInDoctorInfo?.role, "::ROle>>");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const [anchorEl, setAnchorEl] = useState(null);
  const [clientStatus, setClientStatus] = useState(null); // "valid", "invalid", or null
  const [showInvalidDropdown, setShowInvalidDropdown] = useState(false);
  const [selectedInvalidValue, setSelectedInvalidValue] = useState(
    "Invalid or unverifiable medical documentation"
  );
  const [userAllInfo, setUserAllInfo] = useState("");
  const [allPrescriptionIds, setAllPrescriptionIds] = useState("");
  const [userReportData, setUserReportData] = useState("");
  const [prescriptionCount, setPrescriptionCount] = useState("");
  const [noDataErrMessage, setNoDataErrMessage] = useState("");
  const [isUserIdle, setIsUserIdle] = useState(false);
  // const open = Boolean(anchorEl);
  let idleTimeout;

  const prevPendingCountRef = useRef(null);
  const firstCallRef = useRef(true);

  // State for managing dropdown open/close
  const [selectedValue, setSelectedValue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const [secondsRemaining, setSecondsRemaining] = useState(0);
  const countdownIntervalRef = useRef(null);
  const isCancelledByUserRef = useRef(false);

  const [searchText, setSearchText] = useState("");
  const [orderInfoList, setOrderInfoList] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [nextCursor, setNextCursor] = useState("");
  let prescribedListColumn = [];
  let prescribedListColumnKeys = new Set();
  const [dropdownValue, setDropdownValue] = useState("");
  const [filteredPrescribedList, setFilteredPrescribedList] = useState([]);
  const [totalOrdersData, setTotalOrdersData] = useState("");
  let modifiedStartDate = startDate && startDate.format("YYYY-MM-DD");
  let modifiedEndDate = endDate && endDate.format("YYYY-MM-DD");
  const [openFulfillmentDialog, setOpenFulfillmentDialog] = useState(false);
  const [selectedFullfillOrder, setSelectedFullfillOrder] = useState(null);
  const [currPageNumber, setCurrPageNumber] = useState(1);
  const [currPageCursor, setCurrPageCursor] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [clearData, setClearData] = useState(false);

  const refreshParent = () => {
    setRefreshKey((prev) => prev + 1); // Triggers re-render
  };

  const handleSelectFulfillmentOrder = (selectedRow) => {
    setSelectedFullfillOrder(selectedRow);
    setOpenFulfillmentDialog(true);
  };
  const extractTextFromObject = (obj) => {
    let result = [];

    const traverse = (value) => {
      if (value == null) return;
      if (
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
      ) {
        result.push(String(value));
      } else if (Array.isArray(value)) {
        value.forEach(traverse);
      } else if (typeof value === "object") {
        Object.values(value).forEach(traverse);
      }
    };

    traverse(obj);
    return result.join(" ").toLowerCase(); // space-separated string of all primitive values
  };

  useEffect(() => {
    if (orderInfoList && orderInfoList.length > 0) {
      if (!searchText) {
        setFilteredPrescribedList(orderInfoList);
      } else {
        const filteredList = orderInfoList.filter((lab) => {
          const allText = extractTextFromObject(lab);
          return allText.includes(searchText.toLowerCase());
        });

        setFilteredPrescribedList(filteredList);
      }
    }
  }, [orderInfoList, searchText]);

  const generateSizePerPageList = (sizePerPage, totalItems) => {
    const list = [];
    let multiple = sizePerPage;

    while (multiple < totalItems) {
      list.push({ text: multiple.toString(), value: multiple });
      multiple += sizePerPage;
    }
    list.push({ text: "All", value: totalItems });

    return list;
  };

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: sizePerPage,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: generateSizePerPageList(sizePerPage, orderInfoList.length),
    onPageChange: function (page, sizePerPage) {
      setCurrPageNumber(page);
      setCurrPageCursor(nextCursor);
      setPageNumber(page - 1);
      setPageSize(10); // corrected variable from pageSize to sizePerPage
    },
    onSizePerPageChange: function (page, sizePerPage) {
      // Optional: handle size per page change
    },
  });

  const handleSelectFilter = (event) => {
    const selectedValue = event.target.value; // "Prescribed" | "Proscribed"
    setDropdownValue(selectedValue);
    // const filteredList = orderInfoList.filter(
    //   (item) => item.tags == selectedValue // compare string ↔︎ string
    // );
    const filteredList = orderInfoList.filter((item) => {
      return item.tags[0] == selectedValue; // compare string ↔︎ string
    });
    setFilteredPrescribedList(filteredList);
  };

  const startCountdown = () => {
    clearInterval(countdownIntervalRef.current); // Clear existing timer
    isCancelledByUserRef.current = false;
    setSecondsRemaining(119); // Start from 1:59 for accurate countdown

    countdownIntervalRef.current = setInterval(() => {
      setSecondsRemaining((prevSeconds) => {
        if (prevSeconds <= 0) {
          clearInterval(countdownIntervalRef.current);
          if (!isCancelledByUserRef.current) {
            executeLogout();
          }
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);
  };

  const resetIdleTimer = () => {
    clearTimeout(idleTimeout);
    idleTimeout = setTimeout(() => {
      setIsUserIdle(true);
      startCountdown();
    }, 600000); // 5 minutes 5 * 60 * 1000-->600000
  };

  const handleUserActivity = () => {
    if (isUserIdle) {
      setIsUserIdle(false);
    }
    resetIdleTimer();
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click", "touchstart"];
    for (let event of events) {
      window.addEventListener(event, handleUserActivity);
    }
    resetIdleTimer();
    return () => {
      for (let event of events) {
        window.removeEventListener(event, handleUserActivity);
      }
      clearTimeout(idleTimeout);
    };
  }, []);

  // Handle menu open
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  // Handle menu close
  const handleMenuClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login-page");
  };
  // Handle select change
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  let bmiValue =
    (userAllInfo?.weight * 10000) / (userAllInfo?.height * userAllInfo?.height);
  let finalBmiValue = bmiValue.toFixed(2);

  useEffect(() => {
    handleGetOrdersList();
  }, [clearData, pageSize, pageNumber]);

  useEffect(() => {
    modifiedEndDate != null &&
      modifiedEndDate != "" &&
      handleGetOrdersListDateWise();
  }, [modifiedEndDate]);

  // const handleGetOrdersList = async (fullFillStatus) => {
  //   console.log(fullFillStatus, "::>>fullFillStatus>>::");

  //   let reqBody = {
  //     limit: fullFillStatus ? currPageNumber * 10 + 10 : pageSize,
  //     cursor: fullFillStatus ? "" : nextCursor,
  //     start_date: modifiedStartDate,
  //     end_date: modifiedEndDate,
  //   };

  //   setLoading(true);

  //   try {
  //     const response = await axios.post(getCompounderOrderList, reqBody);
  //     setLoading(false);

  //     if (response.status === 200) {
  //       const newOrders = response?.data?.orders || [];

  //       setOrderInfoList((prev) => {
  //         const updatedOrdersMap = new Map();

  //         // Add existing orders to map using 'name' as key
  //         prev.forEach((item) => {
  //           updatedOrdersMap.set(item.name, item);
  //         });

  //         // Update or add new orders
  //         newOrders.forEach((newItem) => {
  //           const existingItem = updatedOrdersMap.get(newItem.name);

  //           if (
  //             !existingItem ||
  //             existingItem.displayFulfillmentStatus !==
  //               newItem.displayFulfillmentStatus
  //           ) {
  //             updatedOrdersMap.set(newItem.name, newItem); // Add or update
  //           }
  //         });

  //         // Return the updated order list
  //         return Array.from(updatedOrdersMap.values());
  //       });

  //       setNextCursor(response?.data?.next_cursor);
  //       setTotalOrdersData(response?.data?.total_order_count);
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error fetching orders:", error);
  //   }
  // };

  const handleGetOrdersList = async (fullFillStatus) => {
    let reqBody = {
      // limit: fullFillStatus ? currPageNumber * 10 + 10 : pageSize,
      limit: fullFillStatus ? 20 : pageSize,
      cursor: fullFillStatus || currPageNumber == 1 ? "" : nextCursor,
      start_date: modifiedStartDate,
      end_date: modifiedEndDate,
    };

    // let reqBody = {
    //   limit: pageSize,
    //   cursor: fullFillStatus ? currPageNumber == 1 || currPageNumber == 2
    //       ? "" : currPageCursor : nextCursor, //fullFillStatus
    //   start_date: modifiedStartDate,
    //   end_date: modifiedEndDate,
    // };
    setLoading(true);

    try {
      const response = await axios.post(getCompounderOrderList, reqBody);
      setLoading(false);

      if (response.status === 200) {
        setClearData(false);
        const newOrders = response?.data?.orders || [];

        setOrderInfoList((prev) => {
          // Create a Set of existing names
          const existingNames = new Set(prev && prev.map((item) => item.name));

          // Filter new orders to only include ones not already in prev list
          const uniqueNewOrders = newOrders.filter(
            (item) => !existingNames.has(item.name)
          );

          // Merge unique new data into previous list
          return [...prev, ...uniqueNewOrders];
        });

        setNextCursor(response?.data?.next_cursor);
        setTotalOrdersData(response?.data?.total_order_count);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching orders:", error);
    }
  };

  const handleGetOrdersListDateWise = async (fullFillStatus) => {
    let dateFilterBody = {
      limit: "",
      cursor: "",
      start_date: modifiedStartDate,
      end_date: modifiedEndDate,
    };

    setLoading(true);

    try {
      const response = await axios.post(getCompounderOrderList, dateFilterBody);
      setLoading(false);

      if (response.status === 200) {
        setOrderInfoList(response?.data?.orders);

        setNextCursor(response?.data?.next_cursor);
        setTotalOrdersData(response?.data?.total_order_count);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching orders:", error);
    }
  };

  const handleLoadAllData = async () => {
    let reqBody = {
      limit: totalOrdersData,
      cursor: nextCursor,
    };
    setLoading(true);

    try {
      const response = await axios.post(getCompounderOrderList, reqBody);
      setLoading(false);

      if (response.status === 200) {
        const newOrders = response?.data?.orders || [];

        setOrderInfoList((prev) => {
          // Create a Set of existing names
          const existingNames = new Set(prev.map((item) => item.name));

          // Filter new orders to only include ones not already in prev list
          const uniqueNewOrders = newOrders.filter(
            (item) => !existingNames.has(item.name)
          );

          // Merge unique new data into previous list
          return [...prev, ...uniqueNewOrders];
        });

        setNextCursor(response?.data?.next_cursor);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching orders:", error);
    }
  };

  const executeLogout = () => {
    toast.success("You have been logged out successfully.");
    localStorage.clear();
    sessionStorage.clear();
    setIsUserIdle(false);
    sessionStorage.removeItem("userLoggedIn");
    sessionStorage.removeItem("loggedInMobileNumber");
    navigate("/login-page", { replace: true });
    window.location.reload();
  };

  const handleCancelClick = () => {
    isCancelledByUserRef.current = true;
    clearInterval(countdownIntervalRef.current);
    setIsUserIdle(false);
  };

  const handleLogoutClick = () => {
    clearInterval(countdownIntervalRef.current);
    executeLogout();
  };

  const handleReloadData = () => {
    // handleGetPrescriptionID();
  };

  // console.log(medicationStatus[0], "::>medicationStatus>>");
  const formatSecondsToTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };

  let columnMap = new Map();

  const preferredOrder = [
    "name", // Order Id
    "customer", // Name of Customer
    // "lineItems", // Product Name
    // "note", // Note
    "shippingAddress",
    // "shippingLine", // Shipping Line
    // "tags",
    "displayFulfillmentStatus",
    "createdAt", // Order Placed
    "processedAt",
    // "updatedAt",
  ];

  orderInfoList.length > 0 &&
    orderInfoList.forEach((item) => {
      const entries = Object.entries(item);
      entries.forEach(([key, value]) => {
        if (!prescribedListColumnKeys.has(key)) {
          let column = {
            dataField: key,
            text: key
              .replace(/_/g, " ")
              .replace(/\b\w/g, (l) => l.toUpperCase()),
            sort: true,
            sortCaret: (order) => {
              if (!order) return <span>&nbsp;⇅</span>;
              if (order === "asc") return <span>&nbsp;↑</span>;
              if (order === "desc") return <span>&nbsp;↓</span>;
            },
            formatter: (cell, row) => {
              if (cell === null || cell === undefined) return "-";
              if (typeof cell === "object" && !Array.isArray(cell)) {
                return Object.values(cell).join(", ");
              }
              return String(cell);
            },
          };

          // Apply custom logic
          if (key === "name") {
            column.text = "Order Id";
            column.formatter = (cell, row) => <p>{row?.name}</p>;
          }
          if (key === "customer") {
            column.text = "Name of Customer";
            column.formatter = (cell, row) => (
              <p>
                {row?.customer?.firstName} {row?.customer?.lastName}
              </p>
            );
          }
          if (key === "createdAt") {
            column.text = "Order Placed";
            column.formatter = (cell, row) => {
              const formattedDate = moment(row?.createdAt).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              return <p>{formattedDate} UTC</p>;
            };
          }
          // if (key === "lineItems") {
          //   column.text = "Product Name";
          //   column.formatter = (cell, row) => (
          //     <p>{row?.lineItems?.edges[0]?.node?.name}</p>
          //   );
          // }
          if (key === "displayFulfillmentStatus") {
            column.text = "Fulfillment Status";
            column.formatter = (cell, row) =>
              row?.displayFulfillmentStatus === "FULFILLED" ? (
                "Fulfilled"
              ) : (
                <button
                  className="fullfillButton"
                  onClick={() => handleSelectFulfillmentOrder(row)}
                >
                  Fulfill Item
                </button>
              );
          }
          // if (key === "note") {
          //   column.text = "Note";
          //   column.formatter = (cell, row) => (
          //     <p className="prescribedStatus">{row?.note}</p>
          //   );
          // }
          if (key === "processedAt") {
            column.text = "Processed At";
            column.formatter = (cell, row) => {
              const formattedDate = moment(row?.processedAt).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              return <p>{formattedDate} UTC</p>;
            };
          }
          // if (key === "shippingLine") {
          //   column.text = "Shipping Line";
          //   column.formatter = (cell, row) => (
          //     <p className="prescribedStatus">{row?.shippingLine?.title}</p>
          //   );
          // }
          // if (key === "tags") {
          //   column.text = "Tags";
          //   column.formatter = (cell, row) => (
          //     <p
          //       className={`${
          //         row?.tags === "prescription_generated"
          //           ? "prescriptionGeneratedLable"
          //           : row?.tags === "prescription_not_generated"
          //           ? "prescriptionNotGeneratedLable"
          //           : ""
          //       }`}
          //     >
          //       {row?.tags === "prescription_generated"
          //         ? "Prescription Generated"
          //         : row?.tags === "prescription_not_generated"
          //         ? "Prescription Not Generated"
          //         : ""}
          //     </p>
          //   );
          // }
          // if (key === "updatedAt") {
          //   column.text = "Updated At";
          //   column.formatter = (cell, row) => {
          //     const formattedDate = moment(row?.updatedAt).format(
          //       "YYYY-MM-DD HH:mm:ss"
          //     );
          //     return <p>{formattedDate} UTC</p>;
          //   };
          // }
          if (key === "shippingAddress") {
            column.text = "Shipping Address";
            column.formatter = (cell, row) => {
              const address = row?.shippingAddress || {};

              const addressParts = [
                address.name,
                address.address1,
                address.address2,
                address.city,
                address.province,
                address.zip,
                address.country,
                address.phone ? `Phone: ${address.phone}` : null,
              ].filter(Boolean);

              return <p>{addressParts.join(", ")}</p>;
            };
          }

          // Hide unwanted columns
          const hiddenKeys = [
            "billingAddress",
            "cancelReason",
            "cancelledAt",
            "currencyCode",
            "discountApplications",
            "displayFinancialStatus",
            "fulfillment_order_gids",
            "fulfillments",
            "id",
            "lineItems",
            "note",
            "subtotalPriceSet",
            "shippingLine",
            "tags",
            "totalPriceSet",
            "totalShippingPriceSet",
            "totalTaxSet",
            "updatedAt",
          ];
          if (hiddenKeys.includes(key)) {
            column.hidden = true;
          }

          // Store column in map for later sorting
          columnMap.set(key, column);
          prescribedListColumnKeys.add(key);
        }
      });
    });

  // Step 3: Push columns in preferred order first
  preferredOrder.forEach((key) => {
    if (columnMap.has(key)) {
      prescribedListColumn.push(columnMap.get(key));
      columnMap.delete(key); // Remove so that remaining can be added later
    }
  });

  // Step 4: Add remaining columns not listed in preferredOrder
  columnMap.forEach((column) => {
    prescribedListColumn.push(column);
  });

  // let transformedData =
  //   orderInfoList.length > 0 &&
  //   orderInfoList.forEach((item) => {
  //     const entries = Object.entries(item);
  //     entries.forEach(([key, value]) => {
  //       if (!prescribedListColumnKeys.has(key)) {
  //         //   let column = { dataField: key, text: key, sort: true };
  //         let column = {
  //           dataField: key,
  //           text: key
  //             .replace(/_/g, " ")
  //             .replace(/\b\w/g, (l) => l.toUpperCase()), // Make key human-readable
  //           sort: true,
  //           sortCaret: (order) => {
  //             if (!order) return <span>&nbsp;⇅</span>;
  //             if (order === "asc") return <span>&nbsp;↑</span>;
  //             if (order === "desc") return <span>&nbsp;↓</span>;
  //           },
  //           formatter: (cell, row) => {
  //             if (cell === null || cell === undefined) return "-";
  //             // If value is object like { No: "No" }
  //             if (typeof cell === "object" && !Array.isArray(cell)) {
  //               return Object.values(cell).join(", ");
  //             }

  //             return String(cell);
  //           },
  //         };
  //         if (key == "name") {
  //           column.text = "Order Id";
  //           column.formatter = (cell, row) => {
  //             return <p>{row?.name}</p>;
  //           };
  //         }
  //         if (key == "customer") {
  //           column.text = "Name of Customer";
  //           column.formatter = (cell, row) => {
  //             return (
  //               <p>
  //                 {row?.customer?.firstName} {row?.customer?.lastName}
  //               </p>
  //             );
  //           };
  //         }
  //         if (key === "createdAt") {
  //           column.text = "Order Placed";
  //           column.formatter = (cell, row) => {
  //             const formattedDate = moment(row?.createdAt).format(
  //               "YYYY-MM-DD HH:mm:ss"
  //             );
  //             return <p>{formattedDate} UTC</p>;
  //             // return <p>{row?.createdAt}</p>;
  //           };
  //         }
  //         if (key == "lineItems") {
  //           column.text = "Product Name";
  //           column.formatter = (cell, row) => {
  //             console.log(row, "::");
  //             return <p>{row?.lineItems?.edges[0]?.node?.name}</p>;
  //           };
  //         }
  //         if (key == "displayFulfillmentStatus") {
  //           column.text = "Fulfillment Status";
  //           column.formatter = (cell, row) => {
  //             return row?.displayFulfillmentStatus === "FULFILLED" ? (
  //               "Fulfilled"
  //             ) : (
  //               <button
  //                 className="fullfillButton"
  //                 onClick={() => handleSelectFulfillmentOrder(row)}
  //               >
  //                 Fulfill Item
  //               </button>
  //             );
  //             // return <p>{row?.displayFulfillmentStatus || "NA"}</p>;
  //           };
  //         }
  //         if (key == "note") {
  //           column.text = "Note";
  //           column.formatter = (cell, row) => {
  //             return <p className="prescribedStatus">{row?.note}</p>;
  //           };
  //         }
  //         if (key == "processedAt") {
  //           column.text = "Processed At";
  //           column.formatter = (cell, row) => {
  //             const formattedDate = moment(row?.processedAt).format(
  //               "YYYY-MM-DD HH:mm:ss"
  //             );
  //             return <p>{formattedDate} UTC</p>;
  //             // return <p className="prescribedStatus">{row?.processedAt}</p>;
  //           };
  //         }
  //         if (key == "shippingLine") {
  //           column.text = "Shipping Line";
  //           column.formatter = (cell, row) => {
  //             return (
  //               <p className="prescribedStatus">{row?.shippingLine?.title}</p>
  //             );
  //           };
  //         }
  //         if (key == "tags") {
  //           column.text = "Tags";
  //           column.formatter = (cell, row) => {
  //             // return <p className="prescribedStatus">{row?.tags}</p>;
  //             return (
  //               <p
  //                 className={`${
  //                   row?.tags == "prescription_generated"
  //                     ? "prescriptionGeneratedLable"
  //                     : row?.tags == "prescription_not_generated"
  //                     ? "prescriptionNotGeneratedLable"
  //                     : ""
  //                 }`}
  //               >
  //                 {row?.tags == "prescription_generated"
  //                   ? "Prescription Generated"
  //                   : row?.tags == "prescription_not_generated"
  //                   ? "Prescription Not Generated"
  //                   : ""}
  //                 {/* {row?.tags} */}
  //               </p>
  //             );
  //           };
  //         }
  //         if (key == "updatedAt") {
  //           column.text = "Updated At";
  //           column.formatter = (cell, row) => {
  //             const formattedDate = moment(row?.updatedAt).format(
  //               "YYYY-MM-DD HH:mm:ss"
  //             );
  //             return <p>{formattedDate} UTC</p>;
  //             // return <p className="prescribedStatus">{row?.updatedAt}</p>;
  //           };
  //         }
  //         if (key === "billingAddress") {
  //           column.hidden = true;
  //         }
  //         if (key === "cancelReason") {
  //           column.hidden = true;
  //         }
  //         if (key === "cancelledAt") {
  //           column.hidden = true;
  //         }
  //         if (key === "currencyCode") {
  //           column.hidden = true;
  //         }
  //         if (key === "discountApplications") {
  //           column.hidden = true;
  //         }
  //         if (key === "displayFinancialStatus") {
  //           column.hidden = true;
  //         }
  //         if (key === "fulfillment_order_gids") {
  //           column.hidden = true;
  //         }
  //         if (key === "fulfillments") {
  //           column.hidden = true;
  //         }
  //         if (key === "id") {
  //           column.hidden = true;
  //         }
  //         if (key === "subtotalPriceSet") {
  //           column.hidden = true;
  //         }
  //         if (key === "totalPriceSet") {
  //           column.hidden = true;
  //         }
  //         if (key === "totalShippingPriceSet") {
  //           column.hidden = true;
  //         }
  //         if (key === "totalTaxSet") {
  //           column.hidden = true;
  //         }
  //         prescribedListColumn.push(column);
  //         prescribedListColumnKeys.add(key);
  //       }
  //     });
  //   });

  const handleGetPrescribedList = async () => {
    const reqBody = {
      doctor_id: loggedInDoctorInfo?.doctor_id,
      start_date: startDate ? startDate.format("YYYY-MM-DD") : "",
      end_date: endDate ? endDate.format("YYYY-MM-DD") : "",
      limit: pageSize,
      offset: pageNumber,
      //   start_date: "2025-06-03",
      //   end_date: "2025-06-11",
    };
    setLoading(true);

    try {
      const response = await axios.post(
        loggedInDoctorInfo?.role == "admin"
          ? getAdminPrescriptionlist
          : getDoctorsPrescriptionlist,
        reqBody
      );
      setLoading(false);
      if (response.status === 200) {
        setOrderInfoList(response?.data);
      }
    } catch (error) {
      setLoading(false);

      console.error("API Error:", error);
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearFunction = () => {
    setOrderInfoList([]);
    setNextCursor("");
    setPageSize(20);
    setSearchText("");
    setDropdownValue("");
    setStartDate(null);
    setEndDate(null);
    setClearData(true);
    // handleGetOrdersList();
    // handleGetPrescribedList();
  };

  return (
    <Box>
      {loading && <MainLoader />}
      {/* header */}
      <AppBar
        position="static"
        sx={{ backgroundColor: "#3C4657", padding: "0 16px" }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            minHeight: "50",
          }}
          className="toolBarApp"
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* <IconButton edge="start" color="inherit" aria-label="menu">
              <MenuIcon />
            </IconButton> */}
            {/* <SidebarComp /> */}
            <Typography
              className="siteHeading"
              variant="h6"
              sx={{ lineHeight: "0px" }}
            >
              Alopexia Compounder
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }} className="">
            {/* <div className="reloadIcon" onClick={() => handleReloadData()}>
              <CachedIcon /> Sync
            </div> */}
            {/* <div className="reportActionButton">
              <Button
                // variant="outlined"
                sx={{ color: "white", marginRight: 2 }}
                className="pendingButton"
              >
                <AssignmentTurnedInOutlinedIcon color="action" />{" "}
                <span>Prescribed</span>:
                <span className="commonBadge submittedIconColor">
                  {prescriptionCount?.validated_count ?? 0}
                </span>
              </Button>
              <Button
                // variant="outlined"
                sx={{ color: "white", marginRight: 2 }}
                className="pendingButton"
              >
                <img src={imgUrl.rejectIcon}></img> &nbsp;{" "}
                <span>Proscribed</span>:
                <span className="commonBadge pendingIconColor">
                  {prescriptionCount?.invalidated_count ?? 0}
                </span>
              </Button>

              <Button
                // variant="outlined"
                sx={{ color: "white", marginRight: 2 }}
                className="pendingButton"
              >
                <PendingActionsIcon color="action" /> <span>Pending</span>:
                <span className="commonBadge OpenIconColor">
                  {prescriptionCount?.pending_cases ?? 0}
                </span>
              </Button>
            </div> */}

            <Box
              display="flex"
              justifyContent="start"
              alignItems="center"
              flexDirection="column"
            >
              <IconButton
                color="inherit"
                onClick={handleMenuOpen}
                sx={{ display: "flex", alignItems: "center", pr: 0 }}
              >
                <img src={imgUrl.DocProfile} alt="profile" />
                <span className="profileText">
                  &nbsp;
                  {loggedInDoctorInfo?.first_name}{" "}
                  {loggedInDoctorInfo?.last_name}
                </span>
                <ArrowDropDownIcon />
              </IconButton>

              <Select
                label="Profile Options"
                className="mainDropdown"
                value={selectedValue}
                onChange={handleChange}
                open={open}
                onClose={handleMenuClose}
                MenuProps={{
                  anchorEl: anchorEl,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                  },
                }}
              >
                <MenuItem value="logout" onClick={handleLogout}>
                  Logout
                </MenuItem>
              </Select>
              {/* </FormControl> */}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <div className="mainContainerSection" key={refreshKey}>
        {/* main content */}
        <Box className="mainBoxSection">
          <div className="searchFilterWrapper">
            <TextField
              placeholder="Search"
              variant="outlined"
              value={searchText}
              onChange={handleSearch}
              fullWidth
              margin="normal"
              className="mainSearchBar"
            />
            {/* {console.log(dropdownValue, "::>>dropdownValue>>")} */}

            {/* <Box sx={{ minWidth: 200 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select Status
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={dropdownValue}
                  label="Select Status"
                  onChange={handleSelectFilter}
                  className="filterMenuItem"
                >
                  <MenuItem
                    value="prescription_generated"
                    className="filterMenuItem"
                  >
                    prescription generated
                  </MenuItem>
                  <MenuItem
                    value="prescription_not_generated"
                    className="filterMenuItem"
                  >
                    prescription not generated
                  </MenuItem>
                </Select>
              </FormControl>
            </Box> */}

            <BasicDateRangePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              handleGetPrescribedList={handleGetPrescribedList}
            />
            <Button
              variant="contained"
              color="success"
              className="clearButton w-15"
              onClick={() => handleClearFunction()}
              disabled={
                !searchText && !startDate && !endDate && !dropdownValue
                  ? true
                  : false
              }
            >
              Clear Filters
            </Button>
          </div>
          <Grid container spacing={2}>
            {/* box grid */}
            <Grid
              size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
              className="LeftGridSection"
            >
              <StyledCard sx={{ padding: 0 }} className="LeftBoxSection">
                <Button
                  variant="contained"
                  color="success"
                  className="clearButton w-15"
                  onClick={() => handleLoadAllData()}
                >
                  Load All Data
                </Button>
                {orderInfoList && orderInfoList.length > 0 && (
                  <div className="prescribedTable">
                    <BootstrapTable
                      className="orderInfoList"
                      keyField="id"
                      data={filteredPrescribedList}
                      columns={prescribedListColumn}
                      pagination={pagination}
                      bootstrap4
                      striped
                      hover
                      condensed
                      sort={true}
                    />
                  </div>
                )}
              </StyledCard>
            </Grid>
          </Grid>
        </Box>
      </div>

      {orderInfoList && orderInfoList.length == 0 && (
        <div className="mainContainerSection">
          <Box className="mainBoxSection">
            <div className="NoreportsText">Data Not Found</div>
          </Box>
        </div>
      )}

      {isUserIdle && (
        <Dialog
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            }
          }}
          open={isUserIdle}
          className="myCustomDialog"
          disableBackdropClick
        >
          <DialogTitle>
            You've been idle for a while. You'll be logged out in{" "}
            <strong>{formatSecondsToTime(secondsRemaining)}</strong>
          </DialogTitle>
          <div className="dialogButtonWrapper">
            <Button
              variant="contained"
              color="success"
              className="acceptButton pendingIconColor"
              onClick={handleCancelClick}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="acceptButton promptLogoutBtn"
              onClick={handleLogoutClick}
            >
              Logout
            </Button>
          </div>
        </Dialog>
      )}

      <FulfillmentDialogueBox
        open={openFulfillmentDialog}
        onClose={() => setOpenFulfillmentDialog(false)}
        onConfirm={() => {}}
        selectedFullfillOrder={selectedFullfillOrder}
        setOpenFulfillmentDialog={setOpenFulfillmentDialog}
        setLoading={setLoading}
        loading={loading}
        handleGetOrdersList={handleGetOrdersList}
        setTotalOrdersData={setTotalOrdersData}
        setNextCursor={setNextCursor}
        setOrderInfoList={setOrderInfoList}
        refreshParent={refreshParent}
      />
    </Box>
  );
};

export default AllPrescribedData;
